import { DeliveryOptionType } from "@jti/store";
export var CheckOutSteps;
(function (CheckOutSteps) {
    CheckOutSteps["Shipping"] = "shipping";
    CheckOutSteps["Delivery"] = "delivery";
    CheckOutSteps["Payment"] = "payment";
    CheckOutSteps["FreeTrial"] = "free trial";
})(CheckOutSteps || (CheckOutSteps = {}));
export var FormFields;
(function (FormFields) {
    FormFields["OrderAttributes"] = "orderAttributes";
    FormFields["DeliveryOption"] = "deliveryOption";
})(FormFields || (FormFields = {}));
export const defaultDeliveryMethod = {
    label: "At home delivery",
    methodCode: DeliveryOptionType.AtHome,
    widgetTagName: "at-home",
    defaultDelivery: false,
    lat: "",
    lon: "",
    flotiqApiKey: "",
};
//# sourceMappingURL=checkout-constants.js.map